// @flow

import { css } from 'styled-components';

export default {
  smallRegular: css`
    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
  `,
  smallBold: css`
    font-size: 12px;
    font-weight: 500;
    line-height: 1.5;
  `,
  bodyRegular: css`
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
  `,
  bodyBold: css`
    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
  `,
  largeRegular: css`
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
  `,
  largeBold: css`
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
  `,
  headerRegular: css`
    font-size: 18px;
    font-weight: 400;
    line-height: 1.25;
  `,
  headerBold: css`
    font-size: 18px;
    font-weight: 500;
    line-height: 1.25;
  `,
  subtitle: css`
    font-size: 22px;
    font-weight: 800;
    line-height: 1.25;
  `,
  largeTitle: css`
    font-size: 24px;
    font-weight: 800;
    line-height: 1.25;

    @media (min-width: 1000px) {
      font-size: 28px;
    }
  `,
  title: css`
    font-size: 22px;
    font-weight: 500;
    line-height: 1.25;
  `,
  menuTitle: css`
    font-size: 24px;
    font-weight: 800;
    line-height: 1.25;
  `,
  metricBold: css`
    font-size: 50px;
    font-weight: 800;
    line-height: 1.25;
  `,
  tickerBold: css`
    font-size: 45px;
    font-weight: 800;
    line-height: 1.25;
  `,
};
